u.BaseElement = class extends HTMLElement {
    /**
     * BaseElement for Unity web components
     */
    createdCallback() {}
    attachedCallback() {}
    detachedCallback() {}
    attributeChangedCallback(attr, oldVal, newVal) {}
    static register(tag) {
        document.registerElement(tag, {
            prototype: this.prototype
        });
    }
};

u.BaseInput = class extends HTMLInputElement {
    /**
     * BaseElement for Unity input web components
     */
    createdCallback() {}
    attachedCallback() {}
    detachedCallback() {}
    attributeChangedCallback(attr, oldVal, newVal) {}
    static register(tag) {
        document.registerElement(tag, {
            prototype: this.prototype,
            extends: 'input'
        });
    }
};

u.BaseSelect = class extends HTMLSelectElement {
    /**
     * BaseElement for Unity select web components
     */
    createdCallback() {}
    attachedCallback() {}
    detachedCallback() {}
    attributeChangedCallback(attr, oldVal, newVal) {}
    static register(tag) {
        document.registerElement(tag, {
            prototype: this.prototype,
            extends: 'select'
        });
    }
};

u.BaseForm = class extends HTMLFormElement {
    /**
     * BaseElement for Unity form web components
     */
    createdCallback() {}
    attachedCallback() {}
    detachedCallback() {}
    attributeChangedCallback(attr, oldVal, newVal) {}
    static register(tag) {
        document.registerElement(tag, {
            prototype: this.prototype,
            extends: 'form'
        });
    }
};

u.AnchorElement = class extends HTMLAnchorElement {
    /**
     * AnchorElement for Unity anchor web components
     */
    createdCallback() {}
    attachedCallback() {}
    detachedCallback() {}
    attributeChangedCallback(attr, oldVal, newVal) {}
    static register(tag) {
        document.registerElement(tag, {
            prototype: this.prototype,
            extends: 'a'
        });
    }
};